<script>
    import { onDestroy, onMount } from 'svelte'
    import { fade } from 'svelte/transition'
    import HypeTrainService from '../../helpers/HypeTrainService'
    import { activeMediaStore } from '../../stores/activeMediaStore'
    import AuthService from '../../helpers/AuthService'
    import { afterPageLoad, params } from '@sveltech/routify'
    import { mediaStore } from '../../stores/mediaStore'
    import { differenceInMilliseconds, formatDistanceToNow } from 'date-fns'

    let queue = []
    let expiryTimer
    let currentLevel = 0

    let playerOne = {
        name: 'Player One',
        playerIndex: 1,
        videoPlayer: undefined,
        isLoading: false,
        isPlaying: false,
        isShowing: false,
    }

    let playerTwo = {
        name: 'Player Two',
        playerIndex: 2,
        videoPlayer: undefined,
        isLoading: false,
        isPlaying: false,
        isShowing: false,
    }

    function invalidatePlayer(index) {
        const player = index === 1 ? playerOne : playerTwo
        if (index === 1) {
            playerOne = player
        } else {
            playerTwo = player
        }
    }
    // need to track highest level achieved so far
    // this number needs to reset when the hype train ends

    const unsubscribe = activeMediaStore.subscribe((media) => {
        // check if this is actually a level up or just a progress update
        // only add media into the queue if its a level up or test event

        if (media?.testEvent) {
            console.log('testevent: ', media)
            currentLevel = media.level
            queue.push(media)
            updateExpiryTimer(media)
            loadMediaSource()
            return
        }

        if (media && isIncreasedLevel(media)) {
            currentLevel++
            queue.push(media)
            updateExpiryTimer(media)
            loadMediaSource()
        }
    })

    onMount(async () => {
        await AuthService.codeLogin($params.key, 'hypetrain')

        playerOne.videoPlayer.addEventListener('canplaythrough', () =>
            handleLoaded(playerOne)
        )

        playerTwo.videoPlayer.addEventListener('canplaythrough', () =>
            handleLoaded(playerTwo)
        )
    })

    onDestroy(() => {
        unsubscribe()
    })

    function handleLoaded(mediaObject) {
        console.log(`${mediaObject.name} is loaded`)
        mediaObject.isLoading = false
        invalidatePlayer(mediaObject.playerIndex)
        handlePlay(mediaObject)
    }

    function loadMediaSource() {
        const isEven = currentLevel % 2 === 0
        const source = queue.shift().url
        if (!isEven) {
            playerOne.videoPlayer.src = source
        } else {
            playerTwo.videoPlayer.src = source
        }
    }

    // function removePlayer(isEven) {
    //     const mediaObject = isEven ? playerOne : playerTwo

    //     if (isEven && playerOne.isPlaying) {
    //         player.pause()
    //         showPlayerOne = false
    //         mediaObject.isPlaying = false
    //     } else if (!isEven && playerTwo.isPlaying) {
    //         player2.pause()
    //         showPlayerTwo = false
    //         mediaObject.isPlaying = false
    //     }

    //     // if is even - remove player and if odd remove player2

    //     !isEven ? player.pause() : player2.pause()
    // }

    function handlePlay(mediaObject) {
        if (mediaObject.isPlaying) {
            console.log(`${mediaObject.name} was already playing, ignoring`)
            return false
        }

        mediaObject.isShowing = true
        mediaObject.isPlaying = true
        invalidatePlayer(mediaObject.playerIndex)
        mediaObject.videoPlayer.play()
        console.log(
            `${mediaObject.name} is now playing and showing: ${mediaObject.isShowing}`
        )

        const alternateMediaObject =
            mediaObject.playerIndex === 1 ? playerTwo : playerOne

        console.log(
            `${alternateMediaObject.name} is now being paused and showing: ${alternateMediaObject.isShowing}`
        )
        alternateMediaObject.isShowing = false
        invalidatePlayer(alternateMediaObject.playerIndex)
        setTimeout(() => {
            alternateMediaObject.videoPlayer.pause()
            alternateMediaObject.videoPlayer.src = null
            alternateMediaObject.isPlaying = false
            invalidatePlayer(alternateMediaObject.playerIndex)
        }, 500)
    }

    // just loops the video
    async function onEnded(element) {
        element.currentTime = 0
        element.play()
    }

    // compare the level from the event to our highest level to make sure its a levelup
    function isIncreasedLevel(media) {
        if (currentLevel < media.level) {
            return true
        } else {
            return false
        }
    }

    function updateExpiryTimer(media) {
        clearTimeout(expiryTimer)
        let timeToExpiry = differenceInMilliseconds(
            new Date(media.expiry),
            new Date()
        )
        if (timeToExpiry < 0) timeToExpiry = 0
        console.log(
            'hypetrain expiry: ',
            formatDistanceToNow(new Date(media.expiry)),
            timeToExpiry,
            'ms'
        )
        expiryTimer = setTimeout(() => {
            console.log('hype train expired, achieved level: ', currentLevel)
            playerOne.videoPlayer.pause()
            playerTwo.videoPlayer.pause()
            playerOne.isShowing = false
            playerOne.isPlaying = false
            invalidatePlayer(1)
            playerTwo.isShowing = false
            playerTwo.isPlaying = false
            invalidatePlayer(2)

            currentLevel = 0
            queue = []
        }, timeToExpiry)
    }
</script>

<div class="video-container h-screen w-screen relative">
    <video
        id="playerOne"
        class="h-100 w-auto absolute {playerOne.isShowing ? 'opacity-100' : 'opacity-0'} transition-opacity ease-in duration-500"
        on:ended={() => onEnded(playerOne.videoPlayer)}
        bind:this={playerOne.videoPlayer}>
        <track kind="captions" />
    </video>
    <div transition:fade>
        <video
            id="playerTwo"
            class="h-100 w-auto absolute {playerTwo.isShowing ? 'opacity-100' : 'opacity-0'} transition-opacity ease-in duration-500"
            on:ended={() => onEnded(playerTwo.videoPlayer)}
            bind:this={playerTwo.videoPlayer}>
            <track kind="captions" />
        </video>
    </div>
</div>

<style>
</style>
